import React, { useEffect } from 'react'
import { Row } from 'react-bootstrap'

import { useAuth } from '../../Hooks/UseAuth';
import { usePlan } from '../../Hooks/UsePlan';
import { useProject } from '../../Hooks/UseProject';
import { useTeams } from '@/Hooks/UseTeam';
import useTranslation from '../../Hooks/UseTranslation';

import ProjectLayout from '@/Layouts/MainLayout/ProjectLayout';
import ContentBody from '@/Layouts/MainLayout/components/ContentBody';
import ContentHeader from '@/Layouts/MainLayout/components/ContentHeader';

import TeamCreator from '../../Components/TeamCreator/TeamCreator'
import TeamMembersSelector from '../../Components/TeamMembersSelector/TeamMembersSelector'
import LeftTeamSide from '@/Components/TeamsPageComponents/LeftTeamSide/LeftTeamSide';
import RightSelectedTeam from '@/Components/TeamsPageComponents/RightTeamSide/RightSelectedTeam';

import './ProjectTeamsPage.scss'

const ProjectTeamsPage = (props: any) => {

  const { t } = useTranslation()

  const { ability, userData } = useAuth()
  const {
    tooManyObservers,
    tooManyCollaborators,
    tooManyTeams,
    showTooManyTeamsModal,
    showTooManyObserversModal,
    showTooManyCollaboratorsModal
  } = usePlan()

  const { project, project_id } = useProject()

  const { teams, teamSelected, selectTeam } = useTeams()

  useEffect(() => {
    if (project._id) {

      if (project.ability) ability.update(project.ability)
    }
  }, [project._id])

  useEffect(() => {

    if (!teams.length) {

      selectTeam(undefined)
    }
  }, [teams])

  useEffect(() => {

    if (teams.length && teamSelected && teamSelected.project !== project_id) {

      selectTeam(teams[0])
    }
  }, [teamSelected, project_id])

  useEffect(() => {

    if (tooManyTeams)
      showTooManyTeamsModal(t('TEAMS:TooManyTeamsTitle'))

    if (tooManyObservers)
      showTooManyObserversModal(t('TEAMS:TooManyObserversTitle'), project.user === userData?.id)

    if (tooManyCollaborators)
      showTooManyCollaboratorsModal(t('TEAMS:TooManyAssistantsOrCollaboratorsTitle'), project.user == userData?.id)
  }, [tooManyTeams, tooManyObservers, tooManyCollaborators])

  return (
    <ProjectLayout menuName="teams" subMenuName="">
      <ContentHeader className="pl4-teams-header pl4-page-header" title={t('TEAMS:PageTitle')} />
      <ContentBody noScroll>
        <Row >
          <LeftTeamSide />
          <RightSelectedTeam />
        </Row>
      </ContentBody>

      <TeamCreator />

      <TeamMembersSelector />
    </ProjectLayout >
  )
}

export default ProjectTeamsPage
